import { useEffect, useState } from 'react';

/** S'abonne à une media query et renvoie son état courant. */
function useMediaQuery(query: string, initial: boolean): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return initial;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const list = window.matchMedia(query);
    const onChange = (): void => {
      setMatches(list.matches);
    };
    onChange();
    list.addEventListener('change', onChange);
    return () => {
      list.removeEventListener('change', onChange);
    };
  }, [query]);

  return matches;
}

/** Vrai si le visiteur a demandé moins d'animation au niveau du système. */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)', false);
}

/**
 * Vrai pour un pointeur fin et survolable (souris, trackpad). Le curseur
 * personnalisé et le Steve-curseur ne s'activent que dans ce cas : sur tactile
 * ils n'auraient rien à suivre.
 */
export function useFinePointer(): boolean {
  return useMediaQuery('(hover: hover) and (pointer: fine)', false);
}
